import { createSlice } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const initialState = {
  areProblemOptionsLoading: false,
  areRatingsOptionsLoading: false,
  isFeedbackModalOpen: false,
  isProblemsModalOpen: false,
  problemOptions: []
};

const fetchFeedbackDenyOptionsRequest = draft => {
  draft.areProblemOptionsLoading = true;
};

const fetchFeedbackDenyOptionsSuccess = (draft, action) => {
  draft.areProblemOptionsLoading = false;
  draft.isProblemsModalOpen = true;
  draft.problemOptions = action.payload;
};

const fetchFeedbackDenyOptionsFailure = draft => {
  draft.areProblemOptionsLoading = false;
};

const fetchFeedbackRatingsRequest = draft => {
  draft.areRatingsOptionsLoading = true;
};

const fetchFeedbackRatingsSuccess = (draft, action) => {
  draft.areRatingsOptionsLoading = false;
  draft.isFeedbackModalOpen = true;
  draft.ratings = action.payload;
};

const fetchFeedbackRatingsFailure = draft => {
  draft.areRatingsOptionsLoading = false;
};

const closeProblemsModal = draft => {
  draft.isProblemsModalOpen = false;
};

const closeFeedbackModal = draft => {
  draft.isFeedbackModalOpen = false;
};

const helpCenterFeedbackSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    fetchFeedbackDenyOptionsRequest,
    fetchFeedbackDenyOptionsSuccess,
    fetchFeedbackDenyOptionsFailure,
    fetchFeedbackRatingsRequest,
    fetchFeedbackRatingsSuccess,
    fetchFeedbackRatingsFailure,
    closeProblemsModal,
    closeFeedbackModal
  }
});
export const {
  actions
} = helpCenterFeedbackSlice;
export const plug = {
  [stateName]: helpCenterFeedbackSlice.reducer
};
export default helpCenterFeedbackSlice.reducer;